import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, CheckCircle } from 'lucide-react';
import { usePopup } from '../context/PopupContext';

const CTASection = ({ showOffer = true }) => {
  const { openPopup } = usePopup();

  return (
    <section className="py-20 bg-gradient-to-br from-[#C0392B] to-[#A93226] relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-white/5 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-white/5 rounded-full blur-3xl" />

      <div className="container mx-auto px-4 relative z-10 max-w-[1320px]">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
            Ready to Protect Your Brand?
          </h2>

          <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed">
            Join thousands of businesses who trust us with their trademark registration. 
            Start your application today and secure your brand's future with our expert legal team.
          </p>

          {/* Features */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 py-8">
            {[
              'Fast Processing',
              'Expert Support',
              'Money-Back Guarantee'
            ].map((feature, index) => (
              <div key={index} className="flex items-center justify-center space-x-2">
                <CheckCircle className="w-6 h-6 text-white flex-shrink-0" />
                <span className="text-white font-medium">{feature}</span>
              </div>
            ))}
          </div>

          {/* Single CTA Button */}
          <div className="flex justify-center items-center pt-4">
            <Button
              onClick={openPopup}
              className="bg-white text-[#C0392B] hover:bg-[#FDFEFE] px-10 py-7 text-xl font-bold transition-all duration-300 hover:shadow-2xl btn-glow-hover group"
            >
              Get Started Now
              <ArrowRight className="ml-3 w-6 h-6 group-hover:translate-x-2 transition-all duration-300" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;